
import React, { createContext, useContext } from 'react';
import { NodeTypeConfig, AIService } from '../types';
import { NodePropertyConfig } from '../utils/propertyPanelRegistry';
import type { DirectoryService } from '../Controller';
import type { DmnService } from '../services/mockDmnService';

export interface EditorActions {
  openModal: (nodeId: string, tabId?: string) => void;
}

export interface EditorServices {
  ai: AIService;
  directory: DirectoryService;
  dmn: DmnService;
}

export interface EditorConfig {
  nodeTypes: Record<string, NodeTypeConfig>;
  nodeCategories: string[];
  propertyRegistry: Record<string, NodePropertyConfig>;
  componentRegistry: Record<string, React.ComponentType<any>>;
  services: EditorServices;
  actions?: EditorActions;
}

const EditorContext = createContext<EditorConfig | null>(null);

export const useEditorConfig = () => {
  const context = useContext(EditorContext);
  if (!context) throw new Error("useEditorConfig must be used within EditorProvider");
  return context;
};

export const EditorProvider: React.FC<{ config: EditorConfig; children: React.ReactNode }> = ({ config, children }) => {
  return <EditorContext.Provider value={config}>{children}</EditorContext.Provider>;
};
